
import { createSlice } from '@reduxjs/toolkit'

import { runsheetsAdapter } from '../adapters/runsheetsAdapter'

export const initialRunsheetState = runsheetsAdapter.getInitialState()

export const runsheetsSlice = createSlice({
  name: 'runsheets',
  initialState: initialRunsheetState,
  reducers: {
    upsertMultipleRunsheets: (state, action) => {
      runsheetsAdapter.upsertMany(state, action.payload)
    },
    replaceAllRunsheets: (state, action) => {
      runsheetsAdapter.setAll(state, action.payload)
    },
    removeMultipleRunsheets: (state, action) => {
      runsheetsAdapter.removeMany(state, action.payload)
    },
    removeOneRunsheet: (state, action) => {
      runsheetsAdapter.removeOne(state, action.payload)
    },
  },
})

export const {
  upsertMultipleRunsheets,
  replaceAllRunsheets,
  removeMultipleRunsheets,
  removeOneRunsheet,
} = runsheetsSlice.actions